import { FC, memo } from 'react';
import { useDispatch } from 'react-redux';
import { ButtonType } from 'antd/lib/button';
import Button from 'antd/lib/button/button';
import Tooltip from 'antd/lib/tooltip';

import { paginationByTypeSelector } from 'store/selectors/listsSelectors';
import { selectStoreSettings } from 'store/selectors/settingsSelectors';
import { userSettingsSelector } from 'store/selectors/userSelectors';
import { setPaginationByTypeAction } from 'store/actions/listsActions';
import { useTypedSelector } from 'hooks/useTypedSelector';
import Settings from 'api/classes/Settings';
import sendNotification, { ENotificationTypes } from 'utils/sendNotification';
import { syncProductsWarningText } from 'components/Settings/constants';
import { EListsTypes } from 'types/listsTypes';

interface IMyStoreSyncProductsBtn {
  type?: ButtonType;
}

const MyStoreSyncProductsBtn: FC<IMyStoreSyncProductsBtn> = ({ type = 'primary' }) => {
  const dispatch = useDispatch();
  const { name } = useTypedSelector(selectStoreSettings);
  const { onBoardingSteps } = useTypedSelector(userSettingsSelector);
  const { syncStatus } = useTypedSelector((state) =>
    paginationByTypeSelector(state, { listType: EListsTypes.ProductsType }));
  const isSyncing = syncStatus === 'syncing';
  const isStoreInfoFulfilled = onBoardingSteps[3] || name;
  const isOpen = isStoreInfoFulfilled ? false : undefined;
  const isDisabled = !isStoreInfoFulfilled || isSyncing;

  const handleProductSynchronization = async() => {
    const { success, error } = await Settings.syncProductsSettings();

    dispatch(setPaginationByTypeAction({ listType: EListsTypes.ProductsType, pagination: { syncStatus: 'syncing' } }));
    if (success) {
      sendNotification(ENotificationTypes.Success, 'Products synchronization started');
    } else {
      sendNotification(ENotificationTypes.Error, error || 'Products synchronization failed');
    }
  };

  return (
    <Tooltip open={isOpen} title={syncProductsWarningText}>
      <Button type={type} disabled={isDisabled} loading={isSyncing} onClick={handleProductSynchronization}>
        Synchronize Products
      </Button>
    </Tooltip>
  );
};

export default memo(MyStoreSyncProductsBtn);
